import ModalContainer from './modal-container'

export default {
    ModalContainer,
}
